import {
  SEND_CALLBACKS,
  SEND_CALLBACKS_SUCCESS,
  SEND_CALLBACKS_ERROR,
} from "./actionTypes";

const initialState = {
  errorSendCallbacks: "",
  loadingSendCallbacks: false,
  status: null,
  successSendCallback: "",
  message: "",
};

const sendCallbacks = (state = initialState, action) => {
  switch (action.type) {
    case SEND_CALLBACKS:
      state = {
        ...state,
        loadingSendCallbacks: true,
      };
      break;
    case SEND_CALLBACKS_SUCCESS:
      state = {
        ...state,
        loadingSendCallbacks: false,
        status: action.payload.status,
        successSendCallback: action.payload.message,
      };
      break;
    case SEND_CALLBACKS_ERROR:
      state = {
        ...state,
        errorSendCallbacks: action.payload,
        loadingSendCallbacks: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default sendCallbacks;
